export const CustomLegend = (props: any) => {
    const { payload } = props;
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                gap: "20px",
                marginBottom: "10px",
                marginTop: "10px",
            }}
        >
            {payload.map((entry: any, index: any) => (
                <div
                    key={index}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                    }}
                >
                    <div
                        style={{
                            width: "12px",
                            height: "12px",
                            backgroundColor: entry.color,
                        }}
                    ></div>
                    <span style={{ color: "black" }}>{entry.value}</span>
                </div>
            ))}
        </div>
    );
};

export const CustomTooltip = ({ active, payload }: any) => {
    const getEntryColor = (entry: any) => {
        return "black";
    };

    if (active && payload && payload.length) {
        return (
            <div
                style={{
                    background: "#fff",
                    padding: "10px",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)",
                }}
            >
                <p>
                    <>{payload[0].payload.name}</>
                </p>
                {payload.map((entry: any, index: any) => (
                    <p
                        key={index}
                        style={{
                            color: getEntryColor(entry),
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                        }}
                    >
                        <div
                            style={{
                                width: "12px",
                                height: "12px",
                                backgroundColor: entry.color,
                            }}
                        ></div>
                        {entry.name}: {entry.value.toLocaleString()}
                    </p>
                ))}
            </div>
        );
    }
    return null;
};
